import React from 'react';
import { FORM_WIDGET_COMPONENTS } from '../../../form/formConstants';
import FormWidget from '../../../form/FormWidget';
import { useI18n } from '../../../i18n/I18n';
import { SCHEDULE_FORM_WIDGET_FIELD_NAMES } from '../constants';
import useScheduleFormWidgetContext from '../useScheduleFormWidgetContext';
import { resolveStateFieldName } from '../utils/form-utils';

export interface ScheduleModeFormWidgetProps {
    name?: string;
    disabled?: boolean;
}

export default function ScheduleModeFormWidget({
    name: nameProp,
    disabled: disabledProp
}: ScheduleModeFormWidgetProps) {
    const t = useI18n();

    const {
        loading,
        disabled,
        specifyDurationFormFieldLabelToken = 'scheduleFormWidget.useDuration.label'
    } = useScheduleFormWidgetContext();

    const name = resolveStateFieldName([nameProp, SCHEDULE_FORM_WIDGET_FIELD_NAMES.DURATION_SPECIFIED]);

    const isWidgetDisabled = disabledProp || disabled || loading;

    return (
        <FormWidget
            component={FORM_WIDGET_COMPONENTS.switch}
            label={t(specifyDurationFormFieldLabelToken)}
            disabled={isWidgetDisabled}
            name={name}
        />
    );
}
